export const MEDICAL_INSURANCE_PROVIDERS_LOAD = 'MEDICAL_INSURANCE_PROVIDERS_LOAD'
export const MEDICAL_INSURANCE_PROVIDERS_LOAD_FULFILLED =
  'MEDICAL_INSURANCE_PROVIDERS_LOAD_FULFILLED'
export const MEDICAL_INSURANCE_PROVIDERS_LOAD_REJECTED = 'MEDICAL_INSURANCE_PROVIDERS_LOAD_REJECTED'
